import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Box, Tooltip, Typography } from "@mui/material";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { DataTable, LaeButton } from "../../../components";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { filterAAFFs, loginAsAAFF } from "../../../services";
import FiltrosAAFF from "../../../components/filtros/filtrosAAFF";
import {useLocation, useNavigate } from "react-router-dom";
import {Login} from '@mui/icons-material';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import criticalWarning from "../../../icons/criticalWarning.svg";


  const AAFF = () => {
  const { t } = useTranslation(['aaff', 'properties', 'suppliers', 'common']);
  const user = useContext(UsuarioContext);
  const [loading, setLoading] = useState(true);
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva,setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const refControladorAborto = useRef();

  // useEffect(() => {
  //   fetchData();
  // }, [recargar]);

  const navigate = useNavigate();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy } = {}) => {
   
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';
    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order,orderBy);

    const payload = {
      // aaff_id: 7,
      filtros,
      params: { page: offset, limit, order,orderBy },
    };

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const controller = new AbortController();
    refControladorAborto.current = controller;

    try {
      setLoading(true);
      const response = await filterAAFFs(payload, { signal: controller.signal });
      if (!controller.signal.aborted) {
        const { meta, data } = response;
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
      } else {
        console.log(error);
      }
    } finally {
      if (!controller.signal.aborted) {
        setLoading(false);
      }
    }
  };


  const formatData = (data) => {
    return data.map((row) => {
      const consultorCae = row.consultants?.find(objeto => objeto.r_consul_servsgroups_aaffs.some(group => group.group_id === 1))
      const consultorLopd = row.consultants?.find(objeto => objeto.r_consul_servsgroups_aaffs.some(group => group.group_id === 2))
      const tecnicoCae = row.technicians?.find(objeto => objeto?.r_tech_aaffs?.some(group => group.group_id === 1))
      return {
        razonSocial: row.razonSocial || row.propertie?.aaff?.nombreContacto,
        nif: row.nif,
        parent_id: row.parent_id,
        id: row.id,
        comunidades: row.pendientesCount + row.visitadasCount + row.renovadasCount + row.renovadasVisitadasCount ?? 0,
        consultorCae: consultorCae ? `${consultorCae.nombre} ${consultorCae.apellidos}` : "",
        consultorLopd: consultorLopd ? `${consultorLopd.nombre} ${consultorLopd.apellidos}` : "",
        tecnico: tecnicoCae ? (
          <span>{tecnicoCae.nombre + " " + tecnicoCae.apellidos}</span>
        ) : (
          "-"
        ),
        comercial:
          row.commercial?.id === "" ||
            row.commercial?.id === null ||
            row.commercial?.id === undefined ? (
            "-"
          ) : (
            <span>
              {row.commercial?.nombre + " " + row.commercial?.apellidos}
            </span>
          ),
        direction: row.direccion || row.propertie?.direccion,
        cp: row.codigoPostal || row.propertie?.codigoPostal,
        municipio: row.municipio || row.propertie?.municipio,
        provincia: row.provincia,
        servicios: row.gestionadaPor || row.propertie?.gestionadaPor,
        hojasVisita: row.visitSheets,
        // proveedores: numProveedoresAAFF(row.properties),
        proveedores: row.suppliersCount,
        // docsPendientes: docsPendientesProvs(row.properties),
        propCaducadas: row.hasPropCaducadas
        
      }
    });
  };

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.admin'),
      overrideFunc: (data, row) => (
        <Link to={"/aaff/" + row.nif + "/comunidades"}>
          {data}
        </Link>
      )
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('common:form.nif').toUpperCase(),
      overrideFunc: (data, row) => row.parent_id ? "" : data
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('columns.province'),
    },
    {
      id: "consultorCae",
      numeric: false,
      disablePadding: false,
      label: t('details.consultantCae').toUpperCase(),
      noObjeto:true,
      overrideFunc: (data, row) => data ? data : "-"
    },
    {
      id: "consultorLopd",
      numeric: false,
      disablePadding: false,
      label: t('details.consultantLopd').toUpperCase(),
      noObjeto:true,
      overrideFunc: (data, row) => data ? data : "-"
    },
    // {
    //   id: "comercial",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "COMERCIAL",
    //   noObjeto:true,
    // },
    {
      id: "tecnico",
      numeric: false,
      disablePadding: false,
      label: t('details.technician').toUpperCase(),
      noObjeto:true,
    },
    {
      id: "comunidades",
      numeric: false,
      disablePadding: false,
      label: t('properties:title').toUpperCase(),
      noObjeto:true,
      overrideFunc: (row) => (
        <Typography>
          {row}
        </Typography>
      ),
    },

    {
      id: "proveedores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers:title').toUpperCase(),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <p>
          {data}
        </p>
      )
    },
    {
      id: "propCaducadas",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data) => (
        <>
          {data ?
            <Tooltip title={t('tooltips.expiredCommunities')} arrow>
              <img src={criticalWarning} width={15} alt={t('tooltips.expiredCommunities')} />
            </Tooltip>
            : null}
        </>
      ),
    },
    {
      id: "login",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Tooltip title={t('common:messages.loginAs', { name: '' })}>
          <div className="bigBtn p-2" onClick={() => loginAsAAFF(row.nif)}>
            <Login fontSize="small" />
          </div>
        </Tooltip>
      )
    },

  ];

  
  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
    // fetchData({ offset: 1, limit: limite, filtros: filtros });
  }

  useEffect(() => {
      return () => {
        if (refControladorAborto.current) {
          refControladorAborto.current.abort();
        }
      };
    }, []);

  return (
    <>
      <BreadCrumb
        rutas={[{ path: "/aaff", label: t('title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('title').toUpperCase()}
          </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <FiltrosAAFF onFilter={filtrarDatos} clearFilter={clearFilters}  filtrosIniciales={busqueda}/>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('messages.noAaff')}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default withRouter(AAFF);
